import { render } from "./SmsTemplatesCreatePage.vue?vue&type=template&id=2534a70b"
import script from "./SmsTemplatesCreatePage.vue?vue&type=script&lang=js"
export * from "./SmsTemplatesCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__